import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import get from 'lodash/get';
import Url from 'url-parse';
import { useSecureFetch } from '@ksxz/gateway';

function getDocumentHeaders() {
  return _getDocumentHeaders.apply(this, arguments);
}
function _getDocumentHeaders() {
  _getDocumentHeaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _context, _context2;
    var req, url, prod;
    return _regeneratorRuntime.wrap(function _callee$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            req = new XMLHttpRequest();
            url = document.location.href;
            prod = new _Promise(function (resolve) {
              if (document.location.search) {
                url = url + '&debugger=1';
              }
              req.open('GET', url, false);
              req.onload = function () {
                resolve(true);
              };
              req.send(null);
            });
            _context5.next = 5;
            return prod;
          case 5:
            return _context5.abrupt("return", _reduceInstanceProperty(_context = _trimInstanceProperty(_context2 = req.getAllResponseHeaders()).call(_context2).split(/\n/)).call(_context, function (pre, acc) {
              var _context3, _context4;
              var offset = _indexOfInstanceProperty(acc).call(acc, ':');
              var key = _trimInstanceProperty(_context3 = acc.substr(0, offset)).call(_context3);
              pre[key] = _trimInstanceProperty(_context4 = acc.substr(offset + 1)).call(_context4);
              return pre;
            }, {}));
          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee);
  }));
  return _getDocumentHeaders.apply(this, arguments);
}

var ENV_STORAGE_KEY = 'woa_release_env';
var env;
function init(_x) {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(force) {
    var domain, headers, _Url, hostname;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (typeof window !== 'undefined') {
              if (window.localStorage) {
                try {
                  env = JSON.parse(window.localStorage.getItem(ENV_STORAGE_KEY));
                } catch (e) {
                  //
                }
              }
            }
            if (!(env && !force)) {
              _context2.next = 8;
              break;
            }
            if (!window.location.host) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", env);
          case 4:
            if (!(!window.location.host && !getter._xOrigin_ && !env.xOrigin)) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return", env);
          case 6:
            if (!(!window.location.host && env.xOrigin == getter._xOrigin_)) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", env);
          case 8:
            domain = typeof window !== 'undefined' && document.domain || '';
            headers = {};
            if (!(typeof window !== 'undefined')) {
              _context2.next = 23;
              break;
            }
            _context2.prev = 11;
            _context2.next = 14;
            return getDocumentHeaders();
          case 14:
            _context2.t0 = _context2.sent;
            if (_context2.t0) {
              _context2.next = 17;
              break;
            }
            _context2.t0 = {};
          case 17:
            headers = _context2.t0;
            _context2.next = 23;
            break;
          case 20:
            _context2.prev = 20;
            _context2.t1 = _context2["catch"](11);
            console.log(_context2.t1);
          case 23:
            // 这一段逻辑是判断私有化/国际版，国内环境不要设置_xOrigin_，因为国内没entry服务
            if (getter._xOrigin_) {
              if (/^(https?:\/\/).+$/.test(getter._xOrigin_)) {
                _Url = new Url(getter._xOrigin_), hostname = _Url.hostname; // 海外
                if (/^.+(\.wps\.com)$/.test(hostname)) {
                  domain = hostname;
                }
                // 国内
                else {
                  headers['x-origin'] = getter._xOrigin_;
                }
              } else {
                console.warn('xOrigin参数不正确，启动将自动切换为国内。');
              }
            }
            if (!headers['x-origin']) {
              _context2.next = 31;
              break;
            }
            _context2.next = 27;
            return useSecureFetch(headers['x-origin'], /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opt) {
                var headers, method, url;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        headers = opt.headers, method = opt.method, url = opt.url;
                        return _context.abrupt("return", window.fetch(url, {
                          method: method,
                          headers: headers
                        }).then(function (res) {
                          return res.text();
                        }));
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }());
          case 27:
            env = _context2.sent;
            env.xOrigin = headers['x-origin'];
            _context2.next = 32;
            break;
          case 31:
            if (/^.+(\.wps\.com)$/.test(domain) || domain === 'wps.com') ; else {
              env = {
                props: {
                  release: 'default'
                }
              };
            }
          case 32:
            if (typeof window !== 'undefined') {
              if (window.localStorage) {
                window.localStorage.setItem(ENV_STORAGE_KEY, _JSON$stringify(env));
              }
            }
            return _context2.abrupt("return", env);
          case 34:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[11, 20]]);
  }));
  return _init.apply(this, arguments);
}
function getter(_x2) {
  return _getter.apply(this, arguments);
}
function _getter() {
  _getter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
    var opt,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            opt = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.next = 3;
            return init(opt.force);
          case 3:
            if (key) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return", env);
          case 7:
            return _context3.abrupt("return", get(env, key));
          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getter.apply(this, arguments);
}
getter._xOrigin_ = '';

export { getter as default };
